import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import { nonames, nameRegExp, partnershipNameRegExp } from "../../variables/Variables";

export default function LegalInformation({ state, onChange }) {
  function handleChange(event) {
    const { id, value } = event.target;
    const inputElement = document.getElementById(id);
    const errorElement = inputElement.nextSibling;

    if (id === "legalName") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The legal name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The only punctuation and special characters allowed are hyphen (-) and ampersand (&).";
        errorElement.style.display = "block";
      } else if (!partnershipNameRegExp.test(value.trim()) || ["corp", "llc", "pllc", "lc", "inc"].includes(value.trim().toLowerCase())) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML =
          "The legal name may not contain any of the following endings: Corp, LLC, PLLC, LC, Inc.";
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    if (id === "dbaname") {
      if (value.trim().length !== 0) {
        if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "The DBA could contain only letters, numbers and & - symbols";
          errorElement.style.display = "block";
        } else if (!nameRegExp.test(value.trim()) || nonames.includes(value.trim().toLowerCase())) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML =
            "The DBA may not contain an ending such as 'LLC', 'LC', 'PLLC', 'PA', 'Corp', or 'Inc'.";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    onChange(event);
  }

  return (
    <>
      <h5>Legal information</h5>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Legal Name of Partnership</strong>
            <br />
            The only punctuation and special characters allowed are hyphen (-) and ampersand (&). The legal name may not
            contain any of the following endings: Corp, LLC, PLLC, LC, Inc.
          </Tooltip>
        }
      >
        <Form.Group controlId="legalName">
          <Form.Label>Name of the Partnership</Form.Label>
          <Form.Control
            type="text"
            pattern="(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
            maxLength="70"
            required
            placeholder="Name"
            onChange={handleChange}
            defaultValue={state ? state.legalName : ""}
            data-hj-allow
          />
          <Form.Control.Feedback type="invalid">Please enter the name of the partnership</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Trade name / Doing business as</strong>
            <br />A trade name or doing business as name is another name under which the business or individual
            operates. These names are identified by the terms &apos;trading as&apos; (TA), &apos;doing business as&apos; (DBA), or &apos;also
            known as&apos; (AKA). To file for a DBA, a separate filing with your state and county must be completed. We will
            send you instructions on how to complete this process. The trade name may not contain an ending such as
            &apos;LLC&apos;, &apos;LC&apos;, &apos;PLLC&apos;, &apos;PA&apos;, &apos;Corp&apos;, or &apos;Inc&apos;.
          </Tooltip>
        }
      >
        <Form.Group controlId="dbaname">
          <Form.Label>DBA of the Partnership</Form.Label>
          <Form.Control
            data-hj-allow
            type="text"
            pattern="(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][pP][aA]$))(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
            maxLength="35"
            placeholder="Optional"
            defaultValue={state ? state.dbaname : ""}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid DBA</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
    </>
  );
}
